export default {
  home: {
    title: 'In-App Tutorials',
    desc: 'Deliver in-app help by embedding videos or guides anywhere within your app. Create, manage, and track in-app tutorials from here.',
    enable: 'Enable In-App Tutorials',
    create: 'Create In-App Tutorial',
    name: 'Name',
    status: 'Status',
    content: 'Content',
    total_views: 'Total Views',
    unique_views: 'Unique Views',
    created_by: 'Creator ',
    last_modified: 'Last Modified',
    actions: 'Actions',
    action: {
      preview: 'Live Preview',
      go_live: 'Go Live',
      disable: 'Disable',
      deactivate: 'Deactivate',
      delete: 'Delete',
      activate: 'Enable',
      edit: 'Edit',
    },
    no_embeds: 'No In-App Tutorials Found',
    upgrade_tooltip: 'Upgrade to enable In-App Tutorials',
  },
  create: {
    preview: 'Live Preview',
    launch: 'Open Editor',
    launch_editor: 'Launch Editor',
    go_live: 'Publish',
    activate: 'Activate',
    content: 'Embed Content',
    add_content: 'Add Content',
    add_content_desc:
      'Choose whether to embed a video or guide within your application.',
    add_video: 'Add Video',
    add_guide: 'Add Guide',
    application_url: 'Entry URL',
    application_url_desc:
      'Enter the URL of the application where the embed code is added.',
    embed_icon: 'Embed Icon',
    embed_icon_desc:
      'Select the icon that will represent this embed in your application.',
    modal_size: 'Modal Size',
    url_placeholder: 'e.g. https://your-app.com/',
    icon_placeholder: 'Select an Icon',
    size_placeholder: 'Select Size',
    embed_hover_text: 'Embed Hover Text',
    embed_hover_text_desc:
      'Enter the text that will appear like a tool tip when users hover over the embed.',
    embed_hover_text_placeholder: 'e.g. Learn more',
    restrict_path_pattern: 'Remove URL variables.',
    path_pattern_error: 'Invalid path pattern',
    open_in_new_tab: 'Open in New Tab',
    open_in_new_tab_desc: 'Open the embed in a new tab when clicked.',
    tagged_url: 'URL Path',
    tagged_url_desc: 'The path of the URL where this embed will appear.',
    start_at_time: 'Start Video at',
    start_at_time_desc: 'Set when the video should start playing.',
  },
  modal: {
    name: 'In-App Tutorial Name',
    delete_title: 'Are you sure you want to delete this embed?',
    delete_desc:
      'This action cannot be undone and will remove the embed from your app.',
    publish_title: 'Are you sure you want to publish this embed?',
    publish_desc:
      'This will make the embed live and available to your users. You can disable it later if needed.',
    disable_title: 'Are you sure you want to disable this embed?',
    disable_desc:
      'This will deactivate the embed and users will no longer see it.',
    enable_title: 'Are you sure you want to enable this embed?',
    enable_desc:
      'This will activate the embed and make it available to your users.',
  },
  configuration: {
    title: 'In-App Tutorials Configuration',
    desc: 'Access the embed code and manage global settings for your in-app tutorials.',
    connected_desc: "You're connected. Open the",
    connected_desc_link: 'Builder page',
    connected_desc_suffix: 'to start creating.',
    save: 'Save Changes',
    code: 'Step 1: Embed Code (Mandatory)',
    code_desc:
      "Paste this code in your application's <b>&lt;head&gt;</b> element.",
    icons: 'Available Icons',
    icons_desc: 'List of available icons for your in-app tutorials.',
    add_icons: 'Add Custom Icons',
    email_tracking: {
      title: 'Step 2: User Identification (Recommended)',
      desc: 'Track who views your In-App Tutorials.',
      how_to_setup: 'Copy User Identification Code',
    },
    avaliable_icons: 'Available Icons',
  },

  analytics: {
    engagement_metrics: 'User Level Metrics',
  },

  advanced: 'Advanced Settings',
};
